import ReferenceMemberPage from "./Pages/ReferenceMemberPage";
import ReferenceVendorPage from "./Pages/ReferenceVendorPage";
import ReferenceAppDownload from "./component/ReferenceAppDownload";
import Layout from "./Pages/Layout";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
  useParams,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./Pages/Home";
import { BetSlipProvider } from "./context/BetSlipContext";
import { ThemeProvider } from "./context/ThemeContext";
import "./app.css";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Casino from "./Pages/Casino";
import { isMobile } from "react-device-detect";
import CasinoMobile from "./Pages/CasinoMobile";
import Auth from "./Pages/Auth";
import {
  ProtectedRoute,
  ProtectedRouteLogin,
} from "./component/ProctectedRoute";
import Account from "./Pages/Account/Account";
import ForgotPassword from "./Pages/ForgotPassword";
import Deposit from "./Pages/Account/Deposit";
import Withdraw from "./Pages/Account/Withdraw";
import Cards from "./Pages/Account/Cards";
import RewardCenter from "./Pages/Account/RewardCenter";
import GameRecord from "./Pages/Account/GameRecord";
import ProfitLoss from "./Pages/Account/ProfitLoss";
import DepositRecord from "./Pages/Account/DepositRecord";
import WithdrawRecord from "./Pages/Account/WithdrawRecord";
import Profile from "./Pages/Account/Profile";
import AccountRecord from "./Pages/Account/AccountRecord";
import SecurityCenter from "./Pages/Account/SecurityCenter";
import InternalMessage from "./Pages/Account/InternalMessage";
import PromotionWeb from "./Pages/PromotionWeb";
import InviteFriends from "./Pages/Account/InviteFriends";
import CustomerSupport from "./CustomerSupport.js/Index";
import Index from "./Pages/Velkie/Index";
import Detail from "./Pages/Velkie/MatchDetail/Detail";
import LeagueVelki from "./Pages/Velkie/LeagueVelki";
import SkyIndex from "./Pages/Sky/Index";
import InPlay from "./Pages/Sky/InPlay";
import DetailSky from "./Pages/Sky/MatchDetail/DetailSky";
import FavouriteVelkie from "./Pages/Velkie/FavouriteVelkie";
import FavouriteSky from "./Pages/Sky/FavouriteSky";
import SportsNew from "./Pages/Sky/SportsNew";
import AccountSky from "./Pages/Sky/AccountSky";
import AccountWeb from "./Pages/Sky/Account/AccountWeb";
import MyBetsWeb from "./Pages/Sky/Account/MyBetsWeb";
import Activitylog from "./Pages/Sky/Account/Activitylog";
import AccountStatement from "./Pages/Sky/Account/AccountStatement";
import BalanceOverview from "./Pages/Sky/Account/BalanceOverview";
import CurrentBet from "./Pages/Velkie/Account/CurrentBet";
import HomeSkyWeb from "./Pages/Sky/WebSky/Home";
import DetailWebSky from "./Pages/Sky/WebSky/Detail";
import Inplay from "./Pages/Sky/WebSky/Inplay";
import FavouriteSkyWeb from "./Pages/Sky/WebSky/FavouriteSky";
import ChangePassword from "./Pages/Account/ChangePassword";
import TemuTicket from "./Pages/Account/TemuTicket";
import Bonus from "./Pages/Account/Bonus";
import Benifits from "./Pages/Account/Benifits";
import Affiliate from "./Pages/Account/Affiliate";
import ResultSky from "./Pages/Sky/ResultSky";
import Turnover from "./Pages/Turnover";
import TermsWeb from "./Pages/TermsWeb";
import FreeSpin from "./Pages/FreeSpin";
import SpinReport from "./Pages/Account/SpinReport";
import RealTimeBonus from "./Pages/Account/RealTimeBonus";

function LegacyCasinoRoute() {
  const { type } = useParams();
  const { search, hash } = useLocation();
  const path = ({ slots: "/rng", live: "/live", fish: "/fish", poker: "/pvp", sports: "/sports" })[type];
  return path ? <Navigate to={`${path}${search}${hash}`} replace /> : (isMobile ? <CasinoMobile /> : <Casino />);
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <I18nextProvider i18n={i18n}>
          <ThemeProvider>
            <AuthProvider>
              <BetSlipProvider>
                <Outlet />
              </BetSlipProvider>
            </AuthProvider>
          </ThemeProvider>
        </I18nextProvider>
      }
    >
      <Route path="/" element={<Home />} />
      <Route path="/help" element={<Home />} />
      <Route path="/member" element={<ReferenceMemberPage />} />{" "}
      <Route path="/terms" element={<TermsWeb />} />{" "}
      <Route
        path="/promotion"
        element={<Navigate to="/promotions" replace />}
      />{" "}
      {isMobile && (
        <>
          {" "}
          <Route
            path="/affiliate"
            element={
              <ProtectedRouteLogin>
                <Affiliate />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/account"
            element={
              <ProtectedRouteLogin>
                <Account />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/deposit"
            element={
              <ProtectedRouteLogin>
                <Deposit />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/deposit/:offerCode"
            element={
              <ProtectedRouteLogin>
                <Deposit />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/inviteFriends"
            element={
              <ProtectedRouteLogin>
                <InviteFriends />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/turnover"
            element={
              <ProtectedRouteLogin>
                <Turnover />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/temuTicket"
            element={
              <ProtectedRouteLogin>
                <TemuTicket />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/bonus"
            element={
              <ProtectedRouteLogin>
                <Bonus />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/benefits"
            element={
              <ProtectedRouteLogin>
                <Benifits />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/gameCenter"
            element={
              <ProtectedRouteLogin>
                <GameRecord />
              </ProtectedRouteLogin>
            }
          />
          <Route
            path="/member/profitandloss"
            element={
              <ProtectedRouteLogin>
                <ProfitLoss />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/depositRecord"
            element={
              <ProtectedRouteLogin>
                <DepositRecord />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/accountRecord"
            element={
              <ProtectedRouteLogin>
                <AccountRecord />
              </ProtectedRouteLogin>
            }
          />
                <Route
            path="/member/spin-report"
            element={
              <ProtectedRouteLogin>
                <SpinReport />
              </ProtectedRouteLogin>
            }
          />
          <Route
            path="/member/securityCenter"
            element={
              <ProtectedRouteLogin>
                <SecurityCenter />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/internalMessage"
            element={
              <ProtectedRouteLogin>
                <InternalMessage />
              </ProtectedRouteLogin>
            }
          />
          <Route
            path="/member/withdrawRecord"
            element={
              <ProtectedRouteLogin>
                <WithdrawRecord />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/profile"
            element={
              <ProtectedRouteLogin>
                <Profile />
              </ProtectedRouteLogin>
            }
          />
          <Route
            path="/member/withdraw"
            element={
              <ProtectedRouteLogin>
                <Withdraw />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/cards"
            element={
              <ProtectedRouteLogin>
                <Cards />
              </ProtectedRouteLogin>
            }
          />{" "}
          <Route
            path="/member/rewardCenter"
            element={
              <ProtectedRouteLogin>
                <RewardCenter />
              </ProtectedRouteLogin>
            }
          />
          <Route
            path="/member/change-password"
            element={
              <ProtectedRouteLogin>
                <ChangePassword />
              </ProtectedRouteLogin>
            }
          />
          <Route
            path="/auth/:type"
            element={
              <ProtectedRoute>
                <Auth />
              </ProtectedRoute>
            }
          />{" "}
          <Route
            path="/forget"
            element={
              <ProtectedRoute>
                <ForgotPassword />
              </ProtectedRoute>
            }
          />
        </>
      )}
      <Route
        path="/customer-support"
        element={
          <ProtectedRouteLogin>
            <CustomerSupport />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/result-sky"
        element={
          <ProtectedRouteLogin>
            <ResultSky />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/sports-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/sports-sky/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/spin-wheel"
        element={
          <ProtectedRouteLogin>
            <FreeSpin />
         </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky-new"
        element={
          <ProtectedRouteLogin>
            <SportsNew />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/account-sky"
        element={
          <ProtectedRouteLogin>
            <AccountSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <FavouriteSky /> : <FavouriteSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/inplay-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <InPlay /> : <Inplay />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/match-detail-sky/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange-velki/current-bet"
        element={
          <ProtectedRouteLogin>
            <CurrentBet />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-velki"
        element={
          <ProtectedRouteLogin>
            <Index />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/favourite-velkie"
        element={
          <ProtectedRouteLogin>
            <FavouriteVelkie />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/league-velki"
        element={
          <ProtectedRouteLogin>
            <LeagueVelki />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/profile"
        element={
          <ProtectedRouteLogin>
            <AccountWeb />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/my-bets"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/profit-loss"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/activity-log"
        element={
          <ProtectedRouteLogin>
            <Activitylog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatement />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/balance-overview"
        element={
          <ProtectedRouteLogin>
            <BalanceOverview />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/member/real-time-bonus"
        element={
          isMobile ? (
            <ProtectedRouteLogin>
              <RealTimeBonus />
            </ProtectedRouteLogin>
          ) : null
        }
      />
      <Route
        path="/casino/:type"
        element={<LegacyCasinoRoute />}
      />{" "}
      <Route path="/promotions" element={<PromotionWeb />} />
      <Route path="/esports" element={<ReferenceVendorPage category="E-Sports" />} />
      <Route path="/cockfight" element={<ReferenceVendorPage category="Cockfight" />} />
      <Route path="/down" element={<Layout><main className="reference-download-page"><ReferenceAppDownload /></main></Layout>} />
      <Route path="/rng" element={<Casino category="slots" />} />
      <Route path="/live" element={<Casino category="live" />} />
      <Route path="/fish" element={<Casino category="fish" />} />
      <Route path="/pvp" element={<Casino category="poker" />} />
      <Route path="/sports" element={<Casino category="sports" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>,
  ),
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
